<template>
  <b-modal :active.sync="active"
    has-modal-card :can-cancel="false"
  >
    <div class="modal-card" style="width:420px; overflow:visible;">
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
            <div class="column">
              <div class="modal-card-title">
                <p class="has-text-centered">Editar Fecha Asignación</p>
                <p class="has-text-centered"> {{ title }}</p>
              </div>
            </div>
        </div>
      </header>
      <section class="modal-card-body" style="overflow:visible;">
        <b-field grouped>
          <b-field label="Fecha asignación" label-position="inside" expanded>
            <b-datepicker
              v-model="startDateNew"
              :first-day-of-week="1"
              :month-names="$moment.months()"
              :day-names="$moment.weekdaysShort()"
              :show-week-number="true"
              placeholder="Click para seleccionar"
              icon="calendar-today">
            </b-datepicker>
          </b-field>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
            <div class="column is-three-fifths">
              <div class="columns">
                <div class="column">
                  <b-button expanded @click="cancel">Cerrar</b-button>
                </div>
                <div class="column">
                  <b-button class="is-primary" expanded @click="updateHistory" :disabled="isLoading">Guardar</b-button>
                </div>
              </div>
            </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import HistoryHorseRiderService from '@/services/HistoryHorseRiderService'

export default {
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedItem: {
      id: null,
      start_date: null
    }
  },
  created () {
  },
  data () {
    return {
      lastTime: null,
      isLoading: false,
      event: null,
      reload: false,
      startDateNew: null,
      title: '',
      originalDate: null
    }
  },
  methods: {
    cancel () {
      this.startDateNew = this.originalDate
      this.$emit('close')
      this.$emit('update:active', false)
      this.isLoading = false
    },
    async updateHistory () {
      this.isLoading = true
      let data = {
        start_date: this.startDateNew
      }
      await HistoryHorseRiderService.updateHistoryHorseRider(this.selectedItem.id, data)
      //this.$emit('close')
      this.$emit('reload-data', true)
      this.$emit('update:active', false)
      this.isLoading = false
    }
  },
  watch: {
    selectedItem (data) {
      this.originalDate = new Date(data.start_date)
      this.startDateNew = new Date(data.start_date)
      this.title = this.selectedItem.rider_presentation + ' - ' + this.selectedItem.horse.name
    }
  },
  computed: {
  }
}
</script>
